module.exports = __webpack_public_path__ + "images/emoji/clock2.ef19898c9eba277fdb36.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock2.png
// module id = BOUd
// module chunks = 1